import React, { Component, Fragment } from 'react';
import { Collapse, IconButton } from '@material-ui/core';
import IconAdd from '@material-ui/icons/Add';
import IconRemove from '@material-ui/icons/Remove';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.min.js';
import uuidv4 from 'uuid/v4';

class AddFieldForm extends Component {

    constructor(props) {
        super(props);
        const fieldToEdit = props.fieldToEdit !== '';
        this.state = {
            isUpdate: fieldToEdit,
            selectedType: '',
            options: ['', '']
        }
    }

    componentWillUnmount() {
        const { isUpdate } = this.state;
        if (isUpdate) {
            this.props.resetFieldToEdit();
        }
    }

    componentDidMount() {
        const { isUpdate } = this.state;
        const { fieldToEdit } = this.props;
        if (isUpdate) {
            this.inputTitle.value = fieldToEdit.title;
            this.inputType.value = fieldToEdit.type;
            this.inputCheckBox.checked = fieldToEdit.isRequired
        }
    }

    onSubmit = (e) => {
        e.preventDefault();
        let { isUpdate, options } = this.state;
        const { fieldToEdit } = this.props;
        const title = e.target['label'].value;
        const isRequired = e.target['isRequired'].checked;
        let type = e.target['type'].value;
        let enumType = e.target['select-type'].value;
        let minimum = Number(e.target['minimum'].value);
        let maximum = Number(e.target['maximum'].value);

        let rows = 1;
        options = options.filter(option => option !== '');
        let origType = type;
        switch (type) {
            case 'textarea':
                type = 'string';
                rows = this.inputRows.value;
                options = undefined;
                break;
            case 'select':
                type = 'string';
                break;
            default:
                options = undefined;
                break;
        }


        if (isUpdate) {
            this.props.onUpdate({
                ...fieldToEdit,
                title,
                type,
                isRequired,
                rows,
                options,
                enumType,
                minimum,
                maximum,
                origType
            });
        } else {
            this.props.onAdd({
                id: uuidv4(),
                title,
                type,
                isRequired,
                rows,
                options,
                enumType,
                minimum,
                maximum,
                origType
            });
        }
        this.setState({
            selectedType: '',
            options: ['', '']
        });
    }

    onTypeChange = (e) => {
        const selectedType = this.inputType.value;
        this.setState({ selectedType });
    }

    renderOption = (index) => {
        return (
            <div className='form-group field'>
                <label>{`Option #${index}`}</label>
                <input
                    className="form-control"
                    type="text"
                />
            </div>
        )
    }

    handleOptionChange = (e, index) => {
        const { options } = this.state;
        options[index] = e.target.value;
        this.setState({ options });
    }

    handleOptionAdd = () => {
        const { options } = this.state;
        options.push('');
        this.setState({ options });
    }

    handleOptionRemove = () => {
        const { options } = this.state;
        options.pop();
        this.setState({ options });
    }

    render() {
        const { isUpdate, selectedType, options } = this.state;
        return (
            <form onSubmit={this.onSubmit}>
                <div className='form-group field field-string'>
                    <label className='control-label'>
                        Field Label
                    </label>
                    <input
                        ref={ref => this.inputTitle = ref}
                        className="form-control"
                        label="Form Title"
                        placeholder=""
                        type="text"
                        name='label'
                        required
                    />
                </div>
                <div className='form-group field'>
                    <label>Field Type</label>
                    <select name='type' onChange={this.onTypeChange} ref={ref => this.inputType = ref} className="form-control">
                        <option value='string'>Text</option>
                        <option value='textarea'>Multi line text</option>
                        <option value='integer'>Number</option>
                        <option value='select'>Select</option>
                    </select>
                </div>
                <Collapse in={selectedType === 'textarea'}>
                    <div className='form-group field'>
                        <label>Number of rows</label>
                        <select name='rows' ref={ref => this.inputRows = ref} className="form-control">
                            <option value='2'>2</option>
                            <option value='3'>3</option>
                            <option value='4'>4</option>
                        </select>
                    </div>
                </Collapse>
                <Collapse in={selectedType === 'integer'}>
                    <div className='form-group field'>
                        <label>Minimum</label>
                        <input
                            className="form-control"
                            placeholder=""
                            type="number"
                            name='minimum'
                        />
                    </div>
                    <div className='form-group field'>
                        <label>Maximum</label>
                        <input
                            className="form-control"
                            placeholder=""
                            type="number"
                            name='maximum'
                        />
                    </div>
                </Collapse>
                <Collapse in={selectedType === 'select'}>
                    <div className='form-group field'>
                        <label>Select Type</label>
                        <select name='rows' name='select-type' className="form-control">
                            <option value='dropdown'>Drop down</option>
                            <option value='radio'>Radio buttons</option>
                        </select>
                    </div>
                    {
                        options.map((option, index) => (
                            <div key={index} className='form-group field'>
                                <label>{`Option #${index + 1}`}</label>
                                <input
                                    className="form-control"
                                    type="text"
                                    value={option}
                                    onChange={(e) => this.handleOptionChange(e, index)}
                                />
                            </div>
                        ))
                    }
                    <div className='row'>
                        <div className='col-6 text-center'>
                            <IconButton onClick={this.handleOptionAdd} style={{ outline: 'none' }}>
                                <IconAdd style={{ fontSize: 16 }} />
                            </IconButton>
                        </div>
                        <div className='col-6 text-center'>
                            <IconButton disabled={options.length < 3} onClick={this.handleOptionRemove} style={{ outline: 'none' }}>
                                <IconRemove style={{ fontSize: 16 }} />
                            </IconButton>
                        </div>
                    </div>
                </Collapse>
                <div className='form-group field field-string mt-3'>
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <div>
                                <input name='isRequired' ref={ref => this.inputCheckBox = ref} type="checkbox" aria-label="Checkbox for following text input" />
                            </div>
                        </div>
                        <span className='ml-2'>Required</span>
                    </div>
                </div>
                <button
                    type="submit"
                    className="btn w-100"
                    style={{ backgroundColor: '#3f51b5', color: '#fff' }}
                >
                    {isUpdate ? 'Update Field' : 'Add Field'}
                </button>
            </form>
        )
    }
}

export default AddFieldForm



// WEBPACK FOOTER //
// ./src/containers/widget/components/Steps/FormCreator/AddFieldForm.js